var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row align-items-center user-select-none"},[_c('div',{staticClass:"mr-8"},[_c('span',{staticClass:"spinner d-inline-block",class:_vm.spinnerClass})]),_vm._v(" "),_c('div',{staticClass:"pt-3 font-size-h6 font-weight-light"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }